<script setup lang="ts">
type Props = {
  viewWidth?: number;
  viewHeight?: number;
};

withDefaults(defineProps<Props>(), {
  viewWidth: 24,
  viewHeight: 24,
});
</script>

<template>
  <svg
    :width="viewWidth"
    :height="viewHeight"
    :viewBox="`0 0 ${viewWidth} ${viewHeight}`"
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
  >
    <slot />
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
}
</style>
